// Styles
import './multi-images.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initMultiImages = (context) => {
  const multiImagesSection = context.closest('.shopify-section');
  if (!multiImagesSection) return;

  const swiperContainer = multiImagesSection.querySelector('.multi-images__images');
  if (swiperContainer && swiperContainer.querySelectorAll('.swiper-slide').length > 1) {
    new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      on: {
        init: function () {
          setTimeout(() => {
            swiperContainer.querySelectorAll('.swiper-slide').forEach(slide => {
              slide.removeAttribute('aria-label');
              slide.removeAttribute('role');
            });
          }, 10);
        }
      },
      breakpoints: {
        769: {
          slidesPerView: 3,
          spaceBetween: 16
        }
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.multi-images__container'), (el) => {
    window.dAgency.initMultiImages(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.multi-images__container'), (el) => {
      window.dAgency.initMultiImages(el);
    });
  });
}
